export type UserType = "Agenciero" | "Interno" | "Productor" | "ClienteFinal";

const maintenanceFlagMap: Record<UserType, string> = {
  Agenciero: "underMaintenanceMkpFrontVendedorAgenciero",
  Interno: "underMaintenanceMkpFrontVendedorInterno",
  Productor: "underMaintenanceMkpFrontVendedorProductor",
  ClienteFinal: "underMaintenanceMkpFrontVendedorClienteFinal",
};

export const isUserTypeInMaintenance = (
  flags: any,
  userType?: UserType
): boolean => {
  if (!userType) return false;
  const flagKey = maintenanceFlagMap[userType];
  return !!flags[flagKey];
};
